import _ from "lodash";
import React, { cloneElement, useState } from "react";
import { compose } from "lib/apolloClient";
import classes from "./ChecklistEditWithReordering.scss";
import { connect } from "react-redux";
import I18nHOC from "UIComponents/I18nHOC";
import { Button, Tooltip, IconButton } from "@toddle-edu/ds-web";
import {
  AssessmentApplicableOutlined,
  AddColumnOutlined,
} from "@toddle-edu/ds-icons";

import {
  createChecklistItem,
  createChecklistOptionItem,
  deleteChecklistOption,
  deleteChecklistItem,
  writeChecklistElementLocal,
} from "Checklist/modules/ChecklistModule";

import { saveAssessmentToolUpdateStatusInRedux } from "Assessments/modules/AssessmentModule";

import { updateField } from "modules/FieldUpdateThunks";
import CheckListEditRowWithReordering from "./CheckListEditRowWithReordering";
import {
  DndContext,
  MouseSensor,
  TouchSensor,
  closestCenter,
  useDraggable,
  useDroppable,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { reorderAssessmentToolItem } from "modules/AssessmentTool/AssessmentToolModule";
import { CHECKLIST } from "Constants/stringConstants";
import { SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import { moveElementInArray } from "Utils";
import {
  getProjectionLineData,
  sortAssessmentTool,
} from "ClassRoom/modules/utils";
import { isEmpty } from "lodash";

const MIN_OPTION_COUNT = 1;
const MAX_OPTION_COUNT = 4;

const styles = {
  rotateIconStyle: {
    transform: "rotate(90deg)",
  },
  transformIconStyle: {
    transform: "rotate(90deg) scaleX(-1)",
  },
};

const DraggableRow = ({
  id,
  children,
  projectedLineData,
  selectedChecklist,
  checklistItems,
}) => {
  const disableDragging = _.some(checklistItems, checklistItem =>
    _.includes(_.get(checklistItem, "id", null), "NEW")
  );
  const props = useDraggable({
    id,
    disabled: selectedChecklist.type === "column" || disableDragging,
  });
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    node,
  } = props;
  let style = {
    transform: !_.isEmpty(transform)
      ? `translate3d(${transform.x}px, ${transform.y}px, 0px)`
      : "",
    transition,
    zIndex: isDragging ? 2000 : "",
    opacity: isDragging ? 0.75 : "",
  };

  const { setNodeRef: setDroppableNodeRef } = useDroppable({
    id,
    disabled: selectedChecklist.type === "column" || disableDragging,
  });

  if (projectedLineData?.id === id) {
    style = { ...style, ...projectedLineData.style };
  }

  return (
    <div
      className={classes.rowContainer}
      ref={ref => {
        setNodeRef(ref);
        setDroppableNodeRef(ref);
      }}
      style={style}
    >
      {cloneElement(children, { node, attributes, listeners, disableDragging })}
    </div>
  );
};

class CheckListComp extends React.PureComponent {
  constructor(props) {
    super(props);
    if (props.customRef) {
      props.customRef(this);
    }
    this.state = { inFocusColumn: null, inFocusRow: null };
    this.focusedCell = null;
    this.cellRefs = {};
  }

  onColumnFocus = id => {
    this.setState({ inFocusColumn: id });
  };

  onRowFocus = id => {
    this.setState({ inFocusRow: id });
  };

  blur = () => {
    if (this.focusedCell && this.cellRefs[this.focusedCell]) {
      this.cellRefs[this.focusedCell].blur();
    }
  };

  setCellRef = ({ key, ref }) => {
    this.cellRefs[key] = ref;
  };

  setFocusedCell = key => {
    this.focusedCell = key;
  };

  render() {
    const {
      checklistItems,
      checklistOptionItems,
      onOptionDeleteClick,
      onItemDeleteClick,
      writeCheckListElement,
      showHoverState,
      writeChecklistElementLocal,
      assignmentId,
      saveAssessmentToolUpdateStatusInRedux,
      setHoverChecklistDetails,
      hoverChecklistDetails,
      setSelectedChecklist,
      selectedChecklist,
      isDragging,
      createEmptyCheckListItem,
      createEmptyCheckListOptionItem,
      projectedLineData,
      indexToFocusData,
      setIndexToFocusData,
    } = this.props;

    const { inFocusColumn, inFocusRow } = this.state;
    const showDeleteIcon = _.size(checklistItems) > 1;

    return (
      <div
        onBlur={() => this.setState({ inFocusColumn: null, inFocusRow: null })}
        className={classes.checkListContainer}
      >
        <SortableContext
          disabled={selectedChecklist.type === "column"}
          items={checklistItems}
          strategy={rectSortingStrategy}
        >
          {_.map(checklistItems, (item, index) => {
            return (
              <DraggableRow key={item?.id} id={item?.id} {...this.props}>
                <CheckListEditRowWithReordering
                  onColumnFocus={this.onColumnFocus}
                  onRowFocus={this.onRowFocus}
                  focusedColumn={inFocusColumn}
                  setCellRef={this.setCellRef}
                  setFocusedCell={this.setFocusedCell}
                  focusedRow={inFocusRow}
                  key={item.id}
                  item={item}
                  label={item.label}
                  options={checklistOptionItems}
                  index={index}
                  minOptionCount={MIN_OPTION_COUNT}
                  onOptionDeleteClick={onOptionDeleteClick}
                  onItemDeleteClick={onItemDeleteClick}
                  id={item.id}
                  writeCheckListElement={writeCheckListElement}
                  showDeleteCriteriaButton={_.size(checklistItems) > 1}
                  showHoverState={showHoverState}
                  writeChecklistElementLocal={writeChecklistElementLocal}
                  setHoverChecklistDetails={setHoverChecklistDetails}
                  hoverChecklistDetails={hoverChecklistDetails}
                  selectedChecklist={selectedChecklist}
                  setSelectedChecklist={setSelectedChecklist}
                  checklistItems={checklistItems}
                  isDragging={isDragging}
                  createEmptyCheckListItem={createEmptyCheckListItem}
                  createEmptyCheckListOptionItem={
                    createEmptyCheckListOptionItem
                  }
                  showChecklistItemDeleteIcon={showDeleteIcon}
                  saveAssessmentToolUpdateStatusInRedux={
                    saveAssessmentToolUpdateStatusInRedux
                  }
                  projectedLineData={projectedLineData}
                  indexToFocusData={indexToFocusData}
                  setIndexToFocusData={setIndexToFocusData}
                />
              </DraggableRow>
            );
          })}
        </SortableContext>
      </div>
    );
  }
}
class CheckListEdit extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { showToolList: false };
    if (props.customRef) {
      props.customRef(this);
    }
    this.checklistComp = null;

    this.debouncedWriteChecklistElementLocal = _.debounce(
      props.writeChecklistElementLocal,
      1000
    );
  }

  blur = () => {
    if (this.checklistComp) {
      this.checklistComp.blur();
    }
  };

  onCopyTool = params => {
    const { onCopyTool } = this.props;
    onCopyTool(params);
    this.setState({ showToolList: false });
  };
  writeCheckListElement = ({ id, type, label, elementDetails }) => {
    const { updateField, portalType } = this.props;

    this.debouncedWriteChecklistElementLocal({
      id,
      type,
      label,
      elementDetails,
    });

    updateField({
      key: id,
      params: {
        id,
        type,
        label,
        portalType,
      },
      type: "CHECKLIST_ELEMENT",
    });
  };

  createEmptyCheckListItem = async params => {
    const { putAfterItemId } = params;
    if (_.startsWith(putAfterItemId, "NEW")) return;

    const {
      createChecklistItem,
      setScrollToBottom,
      checklist: { id: checklistId },
      portalType,
    } = this.props;
    await createChecklistItem({
      label: "",
      checklistId,
      portalType,
      putAfterItemId,
    });
    if (setScrollToBottom) {
      setTimeout(setScrollToBottom);
    }
  };

  createEmptyCheckListOptionItem = async params => {
    const { putAfterItemId } = params;
    if (_.startsWith(putAfterItemId, "NEW")) return;

    const {
      createChecklistOptionItem,
      checklist: { id: checklistId },
      portalType,
    } = this.props;
    await createChecklistOptionItem({
      label: "",
      checklistId,
      portalType,
      putAfterItemId,
    });
  };

  onOptionDeleteClick = optionId => {
    const {
      deleteChecklistOption,
      checklist: { id: checklistId },
      portalType,
    } = this.props;

    deleteChecklistOption({ checklistId, optionId, portalType });
  };

  onItemDeleteClick = item => {
    const {
      deleteChecklistItem,
      checklist: { id: checklistId, checklistItems },
      portalType,
    } = this.props;
    if (checklistItems.length == 1) {
      this.writeCheckListElement({
        id: item.id,
        type: "CHECKLIST_ITEM",
        label: "",
        elementDetails: item,
      });
    } else {
      deleteChecklistItem({ checklistId, itemId: item.id, portalType });
    }
  };

  shouldOptionAddButtonDisabled = () => {
    const { checklistOptionItems } = this.props.checklist || {};

    return (
      (!!checklistOptionItems &&
        checklistOptionItems.length >= MAX_OPTION_COUNT) ||
      _.includes(_.last(checklistOptionItems)?.id, "NEW")
    );
  };

  renderActionButtons = () => {
    const {
      t,
      checklist,
      onClickToolSave,
      showSaveTemplateButton,
      showActionButtons = true,
      actionButtonsUIType = "BUTTON",
    } = this.props;

    if (!showActionButtons) return null;

    const { checklistOptionItems } = checklist || {};

    const isOptionAddButtonDisabled = this.shouldOptionAddButtonDisabled();
    const { checklistItems } = checklist || {};
    const disableAddCriteriaButton =
      _.includes(_.last(checklistOptionItems)?.id, "NEW") ||
      _.includes(_.last(checklistItems)?.id, "NEW");
    const disableAddOptionsButton =
      disableAddCriteriaButton || isOptionAddButtonDisabled;

    const renderButtons = () => {
      switch (actionButtonsUIType) {
        case "BUTTON": {
          return (
            <>
              <div className={classes.borderLeftContainer}>
                <Button
                  dsVersion="2.0"
                  variant="neutral"
                  type="outlined"
                  size={"medium"}
                  onClick={this.createEmptyCheckListItem}
                  icon={
                    <AddColumnOutlined
                      size={"xx-small"}
                      style={{ transform: "rotate(90deg)" }}
                      variant="subtle"
                    />
                  }
                  disabled={disableAddCriteriaButton}
                >
                  {t("common:add_with_label", {
                    label: t("common:lowercase", {
                      text: t("common:row"),
                    }),
                  })}
                </Button>
                <Button
                  dsVersion="2.0"
                  variant="neutral"
                  type="outlined"
                  size={"medium"}
                  onClick={this.createEmptyCheckListOptionItem}
                  icon={
                    <AddColumnOutlined size={"xx-small"} variant="subtle" />
                  }
                  disabled={disableAddOptionsButton}
                >
                  {t("common:add_with_label", {
                    label: t("common:lowercase", {
                      text: t("common:column"),
                    }),
                  })}
                </Button>
              </div>

              {showSaveTemplateButton ? (
                <Button
                  dsVersion="2.0"
                  variant="neutral"
                  type="outlined"
                  size={"medium"}
                  onClick={onClickToolSave}
                >
                  {t("classRoom:save_as_template")}
                </Button>
              ) : null}
            </>
          );
        }
        case "ICON_BUTTON": {
          return (
            <>
              <div className={classes.iconButtonContainer}>
                <Tooltip
                  placement={"top"}
                  tooltip={t("common:add_with_label", {
                    label: t("common:lowercase", {
                      text: t("common:criteria"),
                    }),
                  })}
                  showArrow={true}
                >
                  <IconButton
                    dsVersion="2.0"
                    icon={<AddColumnOutlined variant="subtle" />}
                    variant="neutral"
                    type="plain"
                    style={styles.rotateIconStyle}
                    size={"small"}
                    disabled={disableAddCriteriaButton}
                    onClick={this.createEmptyCheckListItem}
                  />
                </Tooltip>

                <div className={classes.iconSeparator} />

                <Tooltip
                  placement={"top"}
                  tooltip={t("common:add_with_label", {
                    label: t("common:lowercase", {
                      text: t("common:option"),
                    }),
                  })}
                  showArrow={true}
                >
                  <IconButton
                    dsVersion="2.0"
                    icon={<AddColumnOutlined variant="subtle" />}
                    variant="neutral"
                    type="plain"
                    style={styles.transformIconStyle}
                    size={"small"}
                    disabled={disableAddOptionsButton}
                    onClick={this.createEmptyCheckListOptionItem}
                  />
                </Tooltip>
              </div>

              {showSaveTemplateButton ? (
                <Tooltip
                  placement={"top"}
                  tooltip={t("classRoom:save_as_template")}
                  showArrow={true}
                >
                  <IconButton
                    dsVersion="2.0"
                    icon={<AssessmentApplicableOutlined variant="subtle" />}
                    variant="neutral"
                    type="plain"
                    size={"small"}
                    onClick={onClickToolSave}
                  />
                </Tooltip>
              ) : null}
            </>
          );
        }
      }
    };

    return <div className={classes.buttonContainer}>{renderButtons()}</div>;
  };

  render() {
    const {
      t,
      checklist,
      containerStyle,
      showHoverState = false,
      writeChecklistElementLocal,
      assignmentId,
      saveAssessmentToolUpdateStatusInRedux,
      reorderAssessmentToolItem,
    } = this.props;

    if (!checklist) {
      return (
        <div className={classes.emptyText}>
          {t("common:no_checklist_defined")}
        </div>
      );
    }

    const { checklistItems, checklistOptionItems, id } = checklist || {};

    return (
      <div className={classes.container} style={containerStyle}>
        <ChecklistCompWrapper
          ref={ref => (this.checklistComp = ref)}
          createEmptyCheckListItem={this.createEmptyCheckListItem}
          checklistItems={checklistItems}
          checklistOptionItems={checklistOptionItems}
          onOptionDeleteClick={this.onOptionDeleteClick}
          onItemDeleteClick={this.onItemDeleteClick}
          writeCheckListElement={this.writeCheckListElement}
          showHoverState={showHoverState}
          writeChecklistElementLocal={writeChecklistElementLocal}
          assignmentId={assignmentId}
          saveAssessmentToolUpdateStatusInRedux={
            saveAssessmentToolUpdateStatusInRedux
          }
          checklistId={id}
          reorderAssessmentToolItem={reorderAssessmentToolItem}
          createEmptyCheckListOptionItem={this.createEmptyCheckListOptionItem}
        />

        {this.renderActionButtons()}
      </div>
    );
  }
}

const ChecklistCompWrapper = props => {
  const {
    checklistItems,
    checklistOptionItems,
    reorderAssessmentToolItem,
    checklistId,
  } = props;
  const [hoverChecklistDetails, setHoverChecklistDetails] = useState({
    checklistItemId: null,
    checklistOptionIndex: null,
  });
  const [selectedChecklist, setSelectedChecklist] = useState({});
  const [isDragging, setIsDragging] = useState(false);
  const [projectedLineData, setProjectedLineData] = useState({});
  const [indexToFocusData, setIndexToFocusData] = useState({});

  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        distance: 10,
      },
    })
  );

  const onDragStart = event => {
    setIsDragging(true);
    setHoverChecklistDetails({});
    if (_.some(checklistOptionItems, { id: event.active.id })) {
      setSelectedChecklist({
        type: "column",
        id: event.active.id,
      });
    } else {
      setSelectedChecklist({
        type: "row",
        id: event.active.id,
      });
    }
  };

  const onDragMove = params => {
    const { active, over, delta } = params;
    const { id: overId, rect: overRect = {} } = over || {};
    const { id: activeId, rect: activeRect = {} } = active || {};
    const { current = {} } = activeRect || {};
    const { translated = {} } = current || {};
    if (
      _.isEmpty(translated) ||
      !translated.left ||
      !translated.right ||
      isEmpty(selectedChecklist)
    ) {
      return;
    }
    const newProjectedLineData = getProjectionLineData({
      overId,
      overRect,
      activeId,
      delta,
      translated,
      dragType: selectedChecklist.type,
      assessmentToolArray:
        selectedChecklist.type === "column"
          ? checklistOptionItems
          : checklistItems,
    });

    if (!_.isEqual(projectedLineData, newProjectedLineData)) {
      setProjectedLineData(newProjectedLineData);
    }
    return;
  };

  const onDragEnd = async params => {
    //reset states
    setSelectedChecklist({});
    setProjectedLineData({});
    setIsDragging(false);

    const { active, over } = params;
    const activeId = active.id;
    const overId = over.id;

    const items =
      selectedChecklist.type === "column"
        ? checklistOptionItems
        : checklistItems;
    const itemType =
      selectedChecklist.type === "column"
        ? "CHECKLIST_OPTION"
        : "CHECKLIST_ITEM";

    const fromIndex = _.findIndex(items, { id: activeId });
    const toIndex = _.findIndex(items, { id: overId });

    if (activeId !== overId) {
      let putAfterItemId = null;
      if (toIndex > 0) {
        if (fromIndex < toIndex) {
          putAfterItemId = _.get(items, `${[toIndex]}.id`, null);
        } else {
          putAfterItemId = _.get(items, `${[toIndex - 1]}.id`, null);
        }
      } else if (toIndex == _.size(items) - 1) {
        putAfterItemId = _.get(items.last(), `id`, null);
      }
      const updatedValue = moveElementInArray({
        array: items,
        fromIndex,
        toIndex,
      });
      await reorderAssessmentToolItem({
        itemId: activeId,
        itemType,
        putAfterItemId,
        toolType: CHECKLIST,
        toolId: checklistId,
        updatedValue,
      });
    }
  };
  return (
    <DndContext
      collisionDetection={closestCenter}
      sensors={sensors}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragMove={onDragMove}
    >
      <CheckListComp
        selectedChecklist={selectedChecklist}
        setHoverChecklistDetails={setHoverChecklistDetails}
        setSelectedChecklist={setSelectedChecklist}
        hoverChecklistDetails={hoverChecklistDetails}
        {...props}
        isDragging={isDragging}
        projectedLineData={projectedLineData}
        indexToFocusData={indexToFocusData}
        setIndexToFocusData={setIndexToFocusData}
      />
    </DndContext>
  );
};

const mapActionCreators = {
  createChecklistItem,
  createChecklistOptionItem,
  deleteChecklistOption,
  deleteChecklistItem,
  writeChecklistElementLocal,
  updateField,
  saveAssessmentToolUpdateStatusInRedux,
  reorderAssessmentToolItem,
};

const mapStateToProps = (state, ownProps) => {
  const { checklist } = ownProps;

  return {
    checklist: sortAssessmentTool({ tool: checklist, type: CHECKLIST }),
  };
};

CheckListEdit.defaultProps = {
  showSaveTemplateButton: true,
};

export default compose(
  I18nHOC({ resource: "common" }),
  connect(mapStateToProps, mapActionCreators)
)(CheckListEdit);
